import loglevel from 'loglevel'

const log = loglevel.getLogger('torus.js')
log.disableAll()

export default log
